import { useContext, useMemo, useState } from "react";
import styles from "./index.module.scss"
import { RightOutlined, UploadOutlined, CloseCircleFilled } from '@ant-design/icons';
import Utils from "@utils/utils"
import Iconfont from '@utils/Iconfont';
import { RESOURCE_TYPE } from '@utils/CONST'
import UploadCard from "../UploadCard";
import { Popover } from 'antd';
import { GenerateContext } from '../../../hooks/GenerateContext'

const ReferSelectionTrigger = (props) => {
    const {
        setTryonModelKeyList,
        setPoseTryonKeyList,
        setNecklaceTryonKeyList,
        setShoesKeyList,
        setSceneKeyList,
    } = useContext(GenerateContext)

    const {
        // 资源类型
        resourceType,
        // 最大选择数量
        multiple,
        // 上传多个
        uploadMultiple,
        // 仅vip用户可用
        vipOnly,
        // 选中的资源key列表
        value,
        // 触发抽屉的文本
        triggerText,
        // 触发上传的文本
        triggerUploadText,
        // 上传提示
        dragTips,
        // 自定义禁用
        customDisabled,
        // 点击抽屉的回调
        onClick,
        // 点击次级按钮的回调
        onSecondaryClick,
        // 上传文件的回调
        onUpload,
        // 移除选中资源的回调
        onRemove,
        // 打开编辑mask弹窗
        onEditMask
    } = props
    const isColor = useMemo(() => {
        return resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR
    }, [resourceType])
    const isVideo = useMemo(() => {
        return resourceType == RESOURCE_TYPE.VIDEO_MODEL
    }, [resourceType])
    const isSelected = useMemo(() => {
        return value.length > 0
    }, [value])
    const selectedNum = useMemo(() => {
        return value.length
    }, [value])
    const firstPoseKey = useMemo(() => {
        return value?.[0]
    }, [value])
    const handleDefaultDrawer = (e) => {
        e.stopPropagation()
        onClick()
    }
    const handleSecondaryClick = (e) => {
        e.stopPropagation()
        if (customDisabled) return
        onSecondaryClick("custom")
    }
    const handleRemove = (e) => {
        e.stopPropagation()
        onRemove()
    }
    const handleMaskEdit = (e) => {
        e.stopPropagation()
        onEditMask()
    }
    const handleUpload = async (file, fileList, uploadOptions) => {
        // 需要登录
        const status = Utils.checkLoginStatus(() => handleUpload(file, fileList, uploadOptions))
        if (!status) return

        for (let file of fileList) {
            const res = await onUpload(file, uploadOptions)
            if (!res) continue
        }
    }

    const PopoverContent = () => (
        <div className={styles.drawPopoverContent}>
            {
                value?.map((item) => (
                    <div className={styles.PopoverContentItem} key={item.key}>
                        <CloseCircleFilled onClick={() => removeSingleClick(item)} className={styles.closeIcon} />
                        <img src={Utils.getImgThumbnail(item.url)} />
                    </div>
                ))
            }
        </div>
    )
    const removeSingleClick = (item) => {
        const currentList = value.filter((i) => i.key != item.key)
        if (resourceType == RESOURCE_TYPE.TRYON_MODEL) setTryonModelKeyList(currentList)
        else if (resourceType == RESOURCE_TYPE.POSE_TRYON) setPoseTryonKeyList(currentList)
        else if (resourceType == RESOURCE_TYPE.NECKLACE_TRYON) setNecklaceTryonKeyList(currentList)
        else if (resourceType == RESOURCE_TYPE.TRYON_SHOES) setShoesKeyList(currentList)
        else if (resourceType == RESOURCE_TYPE.TRYON_SCENE) setSceneKeyList(currentList)
    }


    // 上传状态
    const [loading, setLoading] = useState(false)
    return (
        <div className={styles.Container} onClick={e => e.stopPropagation()}>
            {isSelected &&
                <div className={styles.SelectedContainer}>
                    {
                        isColor ?
                            <div className={styles.SelectedCover} style={{ backgroundColor: firstPoseKey }}></div> :
                            isVideo ?
                                <video className={styles.SelectedCover} key={firstPoseKey.url} src={firstPoseKey.url} muted autoPlay /> :
                                <>
                                    <img className={styles.SelectedCover} key={firstPoseKey.url} src={Utils.getImgThumbnail(firstPoseKey.url)} />
                                    {firstPoseKey?.attr?.foregroundAlphaMask &&
                                        <img className={styles.SelectedCover} key={firstPoseKey.url + "_mask"} src={Utils.getImgThumbnail(firstPoseKey?.attr?.foregroundAlphaMask)} />}
                                </>
                    }
                    <div className={styles.RemoveBtn} onClick={handleRemove}><Iconfont type="icon-DeleteOutlined" /></div>
                    {/* 商品自定义背景框选擦除主体 */}
                    {(resourceType == RESOURCE_TYPE.GLASSES_TRYON ||
                        // (resourceType == RESOURCE_TYPE.COMMODITY_SCENE && value?.[0]?.attr?.custom) ||
                        resourceType == RESOURCE_TYPE.SIM_TRYON) &&
                        <div className={styles.EditBtn} onClick={handleMaskEdit}>
                            <Iconfont type="icon-editOutlined" />
                        </div>}
                    <Popover content={PopoverContent} trigger="click" placement="bottomRight">
                        {multiple && <div className={styles.SelectNum}>x{selectedNum}</div>}
                    </Popover>
                </div>}
            {
                resourceType == RESOURCE_TYPE.COMMODITY_COLOR || resourceType == RESOURCE_TYPE.CLOTH_RECOLOR ?
                    <div className={styles.DrawerTriggerContainer}>
                        <div className={styles.DrawerTriggerContent} onClick={handleDefaultDrawer}>
                            <div className={styles.DrawerTrigger}><span>{triggerText}</span><RightOutlined /></div>
                            <div className={styles.SecondaryTrigger} onClick={handleSecondaryClick}>
                                <span>调色盘</span>
                                <Iconfont type="icon-ColorPaletteOutlined" />
                            </div>
                        </div>
                    </div> :
                    (resourceType == RESOURCE_TYPE.MODEL) ?
                        <div className={styles.DrawerTriggerContainer}>
                            <div className={styles.DrawerTriggerContent} onClick={handleDefaultDrawer}>
                                <div className={styles.DrawerTrigger}><span>{triggerText}</span><RightOutlined /></div>
                                {triggerUploadText && <div className={`${styles.SecondaryTrigger} ${customDisabled ? styles.disabled : ""}`} onClick={handleSecondaryClick}>
                                    <span>{triggerUploadText}</span>
                                    <UploadOutlined />
                                </div>}
                            </div>
                        </div> :
                        <div className={styles.DrawerAndUploadContainer}>
                            <UploadCard
                                resourceType={resourceType}
                                multiple={uploadMultiple}
                                dragTips={dragTips}
                                disabled={customDisabled}
                                loading={loading}
                                setLoading={setLoading}
                                onUpload={handleUpload}
                            >
                                <>
                                    <div className={styles.DrawerAndUploadContent} onClick={handleDefaultDrawer}>
                                        <div className={`${styles.DrawerTrigger} ${!triggerUploadText && styles.noUploadText}`}><span>{triggerText}</span><RightOutlined /></div>
                                    </div>
                                    {triggerUploadText && <div className={`${styles.UploadTrigger} ${customDisabled ? styles.disabled : ""}`}>
                                        {vipOnly && <i className={styles.VipOnly}></i>}
                                        <span>{triggerUploadText}</span>
                                        <UploadOutlined />
                                    </div>}
                                </>
                            </UploadCard>
                        </div>
            }
        </div>

    )
}

export default ReferSelectionTrigger
